import { RemoteSendContact } from "../../../data/usecase/remote-send-contact"
import { SendContact } from "../../../domain/usecase/send-contact"
import { AxiosHttpClient } from "../../../infra/http-client/axios-http-client"

export const makeSendContact = (): SendContact => {
  const url = String(process.env.REACT_APP_BASEURL)
  const httpPostClient = new AxiosHttpClient()
  return new RemoteSendContact(url, httpPostClient)
}